// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2oLrS","left":"StickyBox_left__3E0IU","right":"StickyBox_right__2Xg5V"};